/* eslint-disable @typescript-eslint/no-explicit-any */
import * as R from 'ramda';

export const buildStructuresLookup = (structures: any[]) => {
  const floors: Record<string, any> = R.mergeAll(structures.map(R.prop('levels')));
  const floorIdToFloor = (floorId: string) => floors[floorId];
  const floorIdToOrdinal = R.pipe(floorIdToFloor, R.prop('ordinal'));
  const floorIdToStructure = (floorId: string) => R.find((s: any) => s.levels && s.levels[floorId])(structures);
  const floorIdToStructureId = (floorId: string) => floorIdToStructure(floorId)?.id;
  return {
    floorIdToOrdinal,
    floorIdToFloor,
    floorIdToStructureId,
    floorIdToStructure,
  };
};
